import { useCallback } from 'react';
import { useTrackEvent } from '~/context/srp/SearchAnalyticsContext';
import { PricingResponse } from '~/services/contracts';
import { ChangeLog } from './useGetPricing';

type OwnProps = {
  changeLog: ChangeLog;
};

export default function useSendPriceUpdateEvent({ changeLog }: OwnProps) {
  const trackEvent = useTrackEvent();

  return useCallback(
    (data: PricingResponse) => {
      if (changeLog.initialCall) return;

      const formattedData = Object.entries(data.vehiclePaymentTermsMapping).map(
        ([key, value]) => ({
          vehicleId: key,
          tileInfo: {
            apr: value.apr,
            estimatedTaxesAndFees: value.estimatedTaxesAndFees,
            downPayment: value.downPayment,
            monthlyPayment: value.monthlyPayment,
            term: value.termInMonths
          }
        })
      );

      trackEvent('mega-srp-pricing-update', {
        requestTrigger: changeLog.softpullRefresh
          ? 'softpullRefresh'
          : 'tradeToggle',
        tileInfo: formattedData,
        financeInfo: data.financeInfo,
        tradeInfo: data.tradeInfo
      });
    },
    [changeLog, trackEvent]
  );
}
